export default __webpack_public_path__ + "static/media/lists_view_icon.acbaedde.svg";